import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getBtsDataRequest: ['response'],
    getBtsDataSuccess: ['response', 'loading'],
    getBtsDataFailure: ['error'],
})

export const getBtsDataTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getBtsDataSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getBtsDataFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getBtsDataRequest = state => state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_BTS_DATA_REQUEST]: getBtsDataRequest,
    [Types.GET_BTS_DATA_SUCCESS]: getBtsDataSuccess,
    [Types.GET_BTS_DATA_FAILURE]: getBtsDataFailure,
})
